import { AuditLogEntry } from './schema'

const PAGES: Record<string, string> = {
    timeslot_group: 'products/time_slots/edit',
    opening_times: 'venue/opening_times/default',
    article: 'products/crud',
    products_list: 'products/crud/productList',
}

export const objectPath = (entry: AuditLogEntry, accountSlug: string): string | null => {
    const page = PAGES[entry.objectType]
    if (!page || entry.action === 'deleted') return null
    return `/account/${accountSlug}/${page}/${entry.objectId}`
}
